<!--
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2023-12-27 15:23:15
 * @FilePath: /smartEarthDemo/src/demo/earth/Histogram.vue
 * @Description: 
-->
<template>
  <div  style="height:100%">
    <div id="csContainer">
    </div>
  </div>
</template>
<script>
import util from "../../components/util"
import {hist} from "../../js/hostogrm"
export default {
    data () {
        return {
         viewer:null
        }
    },
    mounted () {
        this.init();
      
    },
    methods: {
        init() {
            this.viewer=util.getViewer('csContainer',{
              fullscreenButton: false,
              infoBox:true
          });
            this.nithito()
        },
        nithito() {
            var dataSource =new hist();
            dataSource.loadUrl('/demo/static/data/geojson/test.json').then(function() {
            function createSeriesSetter(seriesName) {
                return function() {
                    dataSource.seriesToDisplay = seriesName;
                };
            }
            for (var i = 0; i < dataSource.seriesNames.length; i++) {
                var seriesName = dataSource.seriesNames[i];
                Sandcastle.addToolbarButton(seriesName, createSeriesSetter(seriesName));
                }
             });
            this.viewer.clock.shouldAnimate = false;
            this.viewer.dataSources.add(dataSource);
       }
    },
}
</script>
<style lang="less" scoped>
#csContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
#myChart{
    position: absolute;
    z-index: 50;
    left:360px;
}
</style>